import { useEffect, useState } from 'react';
import type { ApiClient } from '../../api';
import { ErrorState, LoadingState } from '../../muster';

/**
 * Das Vorschaubild einer Kollision — Ist und Soll, Grundriss und Schnitt, als
 * SVG vom Server. Klick vergrößert.
 *
 * ── Warum ein Blob und kein <img src="..."> direkt auf die Adresse ──────
 *
 * Ein einfacher <img>-Verweis sendet kein Bearer-Token — die Anfrage würde
 * mit 401 abgewiesen (dasselbe Muster wie beim PDF-/Datei-Download in
 * api.ts). Deshalb der Umweg über fetch, Blob und eine Objekt-URL.
 *
 * Eingebunden in `Detailkarte.tsx`, sobald `api` und `projektId` dort
 * vorliegen.
 */
export function Vorschaubild({
  api, projektId, kollisionId,
}: {
  api: ApiClient;
  projektId: string;
  kollisionId: string;
}) {
  const [adresse, setAdresse] = useState<string | null>(null);
  const [fehler, setFehler] = useState<unknown>(null);
  const [gross, setGross] = useState(false);

  useEffect(() => {
    let abgebrochen = false;
    let eigeneAdresse: string | null = null;

    setAdresse(null);
    setFehler(null);

    api.koordinationVorschauSvg(projektId, kollisionId)
      .then((url) => {
        if (abgebrochen) {
          URL.revokeObjectURL(url);
          return;
        }
        eigeneAdresse = url;
        setAdresse(url);
      })
      .catch((e) => { if (!abgebrochen) setFehler(e); });

    return () => {
      abgebrochen = true;
      if (eigeneAdresse) URL.revokeObjectURL(eigeneAdresse);
    };
  }, [api, projektId, kollisionId]);

  if (fehler !== null) {
    return (
      <ErrorState
        klein
        meldung="Das Vorschaubild konnte nicht geladen werden."
        technisch={fehler}
      />
    );
  }

  if (!adresse) {
    return <LoadingState text="Vorschaubild wird geladen …" art="spinner" />;
  }

  return (
    <>
      <img
        src={adresse}
        alt="Vorschaubild der Kollision - Ist und Soll, Grundriss und Schnitt"
        style={{
          maxWidth: '100%',
          border: '1px solid var(--linie, #ddd)',
          borderRadius: 3,
          cursor: 'zoom-in',
        }}
        onClick={() => setGross(true)}
      />

      {gross && (
        <div
          className="dialoghintergrund"
          onClick={() => setGross(false)}
        >
          <div className="dialog" style={{ maxWidth: '90vw', padding: 12 }}>
            <img
              src={adresse}
              alt="Vorschaubild der Kollision, vergrößert"
              style={{ maxWidth: '86vw', maxHeight: '86vh', cursor: 'zoom-out' }}
            />
          </div>
        </div>
      )}
    </>
  );
}
